import '../styles/navbar.css';

const Navbar = () => {
    return (
        <header>
        <nav>
            <div class="logo">Pushpak<span class="accent">.</span></div>
            <div class="menu-toggle" id="mobile-menu">
                <i class="fas fa-bars"></i>
            </div>
            <ul class="nav-links">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
            </ul>
            </nav>
        </header>
    )
}

export default Navbar;